
const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/52d3c01658e897ec307c501ee9235e1c.jpg')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center text-white">
          <h2 className="text-5xl lg:text-7xl font-bold mb-6 leading-tight">
            Professionelle <br />
            <span className="text-teal-400">Drohnen-Dienstleistungen</span>
          </h2>
          <p className="text-xl lg:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed">
            Hochpräzise Vermessungen, Such- und Rettungsaktionen sowie Photovoltaik-Inspektionen 
            für Gemeinden, Städte und Ingenierbüros in ganz Süddeutschland
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={scrollToContact}
              className="bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Jetzt Anfrage stellen
            </button>
            <button 
              onClick={() => {
                const element = document.getElementById('services');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap"
            >
              Mehr erfahren
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
